import { inject } from '@angular/core';
import { SessionService } from '../services/session.service';

export const managerGuard = () => {
	const sessionService: SessionService = inject(SessionService);
	return sessionService.defaults.isManager;
}